import type { FunctionComponent } from "react";

import { Comment, Container, Name, Quote, Star, Stars } from "./styles";

type Props = {
  comment: string;
  name: string;
  score: number;
};

export const TestimonialItem: FunctionComponent<Props> = ({ comment, name, score }) => {
  const stars = [];
  for (let index = 0; index < 5; ++index) {
    stars.push(<Star $isActive={index + 1 <= score} key={index} />);
  }

  return (
    <Container>
      <Quote />
      <Comment>{comment}</Comment>
      <Stars>{stars}</Stars>
      <Name>{name}</Name>
    </Container>
  );
};

TestimonialItem.displayName = "TestimonialItem";
